import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./rightresource.css";
// import { CheckCircle } from 'lucide-react'; // Using Lucide React for icons
import { HiCheckCircle } from "react-icons/hi2";
import auto_stories from "../../../assets/images/auto_stories.png";
import books_movies_and_music from "../../../assets/images/books_movies_and_music.png";
import edit_audio from "../../../assets/images/edit_audio.png";
import { useLocation } from "react-router-dom";
import blue_check_circle from "../../../assets/images/blue_check_circle.png";

const ExpectedOutcomesAndResources = () => {
  const location = useLocation();
  const resource = location.state?.resource; // Get passed resource data
  //   console.log(resource);

  const outCome = resource?.expectedOutcomes || []; // Ensure it's an array
  //   console.log(outCome);

  const resources = resource?.resources || []; // Ensure it's an array
  //   console.log(resources);
  return (
    <div className="containerright">
      <div className="mid-comtainerright">
        {/* Expected Outcomes - Wider & Shorter */}
        <div className="insiderightcont">
          <div className="bg-white p-4 rounded-4 text-center d-flex flex-column justify-content-center h-100">
            <h3 className="header-text">Expected Outcomes</h3>
            <ul className="list-unstyled">
              {outCome.length > 0 ? (
                outCome.map((outcome, index) => (
                  <li
                    key={index}
                    className="d-flex align-items-center mb-2 no-wrap"
                  >
                    {/* <HiCheckCircle className="text-success me-2" size={17} /> */}
                    <img
                      src={blue_check_circle}
                      alt="Books"
                      className="text-success me-2"
                    />
                    <span className="small-text">{outcome}</span>
                  </li>
                ))
              ) : (
                <li>No outcomes available.</li>
              )}
            </ul>
          </div>
        </div>

        {/* Resources - Wider & Shorter */}
        <div className="insidleftcont bg-white">
  <div className="bg-white p-4 rounded-4 h-100 resource">
    <h3 className="header-text">Resources</h3>

    <div className="row text-center scrollable-container">
      
      {/* Books Column */}
      <div className="col-md-4">
        <img src={auto_stories} alt="Books" className="resource-icon" />
        <strong className="small-heading">Books</strong>
        <div className="scrollable-list">
          <ul className="list-unstyled resource-text">
            {resources.books?.length > 0 ? (
              resources.books.map((book, index) => <li key={index}>{book}</li>)
            ) : (
              <li>No books available.</li>
            )}
          </ul>
        </div>
      </div>

      {/* Courses Column */}
      <div className="col-md-4">
        <img src={books_movies_and_music} alt="Courses" className="resource-icon" />
        <strong className="small-heading">Courses</strong>
        <div className="scrollable-list">
          <ul className="list-unstyled resource-text">
            {resources.courses?.length > 0 ? (
              resources.courses.map((course, index) => <li key={index}>{course}</li>)
            ) : (
              <li>No courses available.</li>
            )}
          </ul>
        </div>
      </div>

      {/* Tools Column */}
      <div className="col-md-4">
        <img src={edit_audio} alt="Tools" className="resource-icon" />
        <strong className="small-heading">Tools</strong>
        <div className="scrollable-list">
          <ul className="list-unstyled resource-text">
            {resources.tools?.length > 0 ? (
              resources.tools.map((tool, index) => <li key={index}>{tool}</li>)
            ) : (
              <li>No tools available.</li>
            )}
          </ul>
        </div>
      </div>

    </div>
  </div>
</div>

      </div>
    </div>
  );
};

export default ExpectedOutcomesAndResources;
